export default __webpack_public_path__ + "locales/ja-JP/Settings.json?hash=bfa15705be7e9d043075a1e2cbd494f6";